import React, { useEffect } from "react";
import "../IndexPage/IndexPage.css";

function SakePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="sakenew-background"></div>
      <div className="card-container">
        <img className="pdf-sake" src="img/sake%20(1).png" alt="Sake"></img>
      </div>
    </div>
  );
}

export default SakePage;
